import moment from 'moment';

const validityCheck = (orderData, order_id) => {

  const orderDateTime = moment(orderData?.orderTime, "YYYY-MM-DD HH:mm:ss");
  const systemDateTime = moment();
  
  const diffHoursDifferentDate = parseInt(process.env.REACT_APP_DIFF_HOURS_DIFFERENT_DATE) || 2;
  const diffHoursSameDate = parseInt(process.env.REACT_APP_DIFF_HOURS_SAME_DATE) || 3;

  const isSameDate = orderDateTime.isSame(systemDateTime, 'day');

  if (!isSameDate) {
    const hoursDiff = systemDateTime.diff(orderDateTime, 'hours');
    if (hoursDiff > diffHoursDifferentDate) {
      console.log(`Print for order ${order_id} is too old (different date, ${hoursDiff} hours difference)`);
      return false;
    }
  } else {
    const hoursDiff = systemDateTime.diff(orderData.orderTime, 'hours');
    if (hoursDiff > diffHoursSameDate) {
      console.log(`Print for order ${order_id} is too old (same date, ${hoursDiff} hours difference)`);
      return false;
    }
  }

  return true;
};

export default validityCheck;